<button
  nz-popconfirm
  [nzPopconfirmTitle]="descrption"
  (nzOnConfirm)="onConfirm()"
  nzPopconfirmPlacement="rightTop"
  [nzIcon]="iconTpl"
  [nzPopconfirmOverlayStyle]="{ width: '750px' }"
  class="ms-2">
  <img src="assets/images/Shared/info_gray.svg" alt="info" />
</button>

<ng-template #iconTpl>
  <span
    nz-icon
    nzType="question-circle"
    nzTheme="fill"
    class="color-icon"></span>
</ng-template>
